// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import ClipboardJS from 'clipboard/dist/clipboard.min';
import 'simplelightbox/dist/simple-lightbox.jquery.min';
import 'slick-carousel/slick/slick';
import 'slick-lightbox-latest/dist/slick-lightbox.min';
import '../scripts/page-template/page-builder/whatsapp-submission';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
});

// Load Events
jQuery(function ($) {
  routes.loadEvents();

  // slick carousel settings
  $('.related-article-slider').slick({
    mobileFirst: true,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '100px',
    responsive: [{
      breakpoint: 960,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '100px',
      },
    },{
      breakpoint:300,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '40px',
      },
    }],
  });
  
  // eslint-disable-next-line no-undef
  var clipboard = new ClipboardJS('.copy-button');

  clipboard.on('success', function(e){
    $(e.trigger).find('span').html('Copied!')
  })
});



// WEBPACK FOOTER //
// ./scripts/single.js